var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmenityUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.25 47.83a2.49 2.49 0 0 1-1.54-.53L50 16.95 11.29 47.3a2.5 2.5 0 1 1-3.09-3.93L48.46 11.8a2.5 2.5 0 0 1 3.08 0l40.25 31.56a2.5 2.5 0 0 1-1.54 4.47ZM80.92 95.1H19.08a2.5 2.5 0 0 1-2.5-2.5V54.83a2.5 2.5 0 0 1 5 0V90.1h56.84V54.75a2.5 2.5 0 0 1 5 0V92.6a2.5 2.5 0 0 1-2.5 2.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenityUnknown);
export default __webpack_public_path__ + "static/media/amenity_unknown.28b2a34cdf996150f47fda2e5845111b.svg";
export { ForwardRef as ReactComponent };